document.addEventListener("DOMContentLoaded", function () {
  let lazybg = [...document.querySelectorAll('[data-lazy-bg]')];

  if ("IntersectionObserver" in window) {
    let observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (entry.target.hasAttribute('data-lazy-bg')) {
            entry.target.style.backgroundImage = `url(${entry.target.getAttribute('data-lazy-bg')})`;
          }
          observer.unobserve(entry.target);
        }
      });
    });

    lazybg.forEach(function (element) {
      observer.observe(element);
    });
  }
});